export default "__VITE_ASSET__Bq0gC_4l__"